var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-wrapper"},[_c('skeleton-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"base-skeleton",attrs:{"is-visible":true}},[_c('div')]),_c('client-only',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }